import _ from 'lodash';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import WorkflowActions from '../actions/WorkflowActions';

import {
  ITEM_TRANSACTION_WORKFLOW,
  ADDED_TO_SHELF_WORKFLOW,
  SAVED_SEARCH_WORKFLOW,
  BATCH_ADDED_TO_SHELF_WORKFLOW,
  BATCH_CANCEL_HOLD_WORKFLOW
} from '../constants/WorkflowConstants';

import ItemTransactionWorkflowContainer from '../containers/ItemTransactionWorkflowContainer';
import AddedToShelfWorkflowContainer from './AddedToShelfWorkflowContainer';
import SaveSearchContainer from './SaveSearchContainer';
import BatchAddToShelfWorkflow from '../components/borrowing/shared/BatchAddedToShelfWorkflow';
import BatchCancelHoldWorkflowContainer from './BatchCancelHoldWorkflowContainer';

function WorkflowContainer(props) {
  const currentWorkflowName = props.workflow && props.workflow.get('name');
  const boundWorkflowActions = _.mapValues(props.actions, action => action.bind(this, props.id));
  let workflowComponent = null;
  const closeWorkflow = () => boundWorkflowActions.updateWorkflow(null);
  switch (currentWorkflowName) {
    case ITEM_TRANSACTION_WORKFLOW:
      workflowComponent = (
        <ItemTransactionWorkflowContainer
          workflowId={props.id}
          metadataId={props.workflow.getIn(['view', 'metadataId'])}
          messagingId={props.workflow.getIn(['view', 'messagingId'])}
          holdsId={props.workflow.getIn(['view', 'holdsId'])}
          closeWorkflow={closeWorkflow}
          view={props.workflow.getIn(['view', 'step'])} />
      );
      break;
    case ADDED_TO_SHELF_WORKFLOW:
      workflowComponent = <AddedToShelfWorkflowContainer id={props.id} metadataId={props.workflow.get('metadataId')} closeWorkflow={closeWorkflow} view={props.workflow.get('view')} />;
      break;
    case SAVED_SEARCH_WORKFLOW:
      workflowComponent = <SaveSearchContainer closeWorkflow={closeWorkflow} />;
      break;
    case BATCH_ADDED_TO_SHELF_WORKFLOW:
      workflowComponent = (
        <BatchAddToShelfWorkflow
          workflowId={props.id}
          closeWorkflow={closeWorkflow}
          shelfName={props.workflow.getIn(['view', 'shelfName'])} />
      );
      break;
    case BATCH_CANCEL_HOLD_WORKFLOW:
      workflowComponent = (
        <BatchCancelHoldWorkflowContainer
          workflowId={props.id}
          closeWorkflow={closeWorkflow}
          holdIds={props.workflow.get('view')} />
      );
      break;
    default:
      workflowComponent = null;
      break;
  }

  return props.children(workflowComponent, boundWorkflowActions);
}

WorkflowContainer.displayName = 'WorkflowContainer';
WorkflowContainer.propTypes = {
  id: PropTypes.string,
  workflow: ImmutablePropTypes.mapContains({
    name: PropTypes.string,
    view: PropTypes.any
  }),
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  children: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;
  return {
    workflow: state.getIn(['ui', 'workflow', id]),
    id
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(WorkflowActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkflowContainer);



// WEBPACK FOOTER //
// ./app/containers/WorkflowContainer.jsx